import React from 'react';
import { Button } from 'reactstrap';
export default function LoadingButton(props) {
    return props.loading ? React.createElement(Button, Object.assign({}, props, { loading: undefined, disabled: true }),
        React.createElement("i", { className: "fas fa-spin fa-circle-notch" })) : React.createElement(Button, Object.assign({}, props, { loading: undefined }));
}
